import { CreateAllData } from '@/apiError/apiCreate';
import { ShowAllData } from '@/apiError/apiShow';
import '@/assets/style/createCompany.scss';
import { AntButton } from '@/common/ant-components/AntButton';
import RadioButtonGroup from '@/common/ant-components/RadioGroupReport';
import {
  getAdFromBS,
  getTodayDate,
} from '@/common/custom-date-selector/helpers';
import { NewNepaliDatePicker } from '@/common/customNepaliDatePicker';
import { dateDisabled } from '@/pages/transaction/reuse/helpers';
import GlobalDivider from '@/utils/divider/GlobalDivider';
import {
  calculateEighteenCaratPrice,
  calculateTwentyTwoCaratPrice,
} from '@/utils/formula/CodeWindow';
import LoadingOverlay from '@/utils/loading/loadingOverlay';
import GlobalModal from '@/utils/modal/Modal';
import { STATUS } from '@/utils/statusCode';
import { Button, Col, DatePicker, Form, Input, Row, Space, theme } from 'antd';
import dayjs from 'dayjs';
import Cookies from 'js-cookie';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { showToast } from '@/utils/toastMessage/ToastMessage';
import {
  dateType as backendDateType,
  getBsFromAD,
} from '@/common/custom-date-selector-list/helpers';
import useAppData from '@/hooks/useAppData';
import { getTodaysDateMYD } from '@/utils/date/TodaysDate';

/**
 * Today's gold rate
 * @returns {JSX.Element}
 */
const TodayGoldRate = ({
  refreshTable = () => {},
  onClose,
  fromTransaction = false,
}) => {
  const { token } = theme.useToken();

  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalType, setModalType] = useState('');
  const primaryCalculationType = Cookies.get('primaryCalculationType');

  /**
   * calculate twenty two carat and eighteen carat according to the price the 24 carat gold
   * @param {*} price today gold price
   */
  const calculate = (price) => {
    form.setFieldsValue({
      twentyTwoCarat: calculateTwentyTwoCaratPrice(price),
      eighteenCarat: calculateEighteenCaratPrice(price),
    });
  };

  /**
   * Displays the modal for creating a new ledger account.
   */
  const showCreateModal = () => {
    setModalType('create');
    setIsModalVisible(true);
  };

  /**
   * Displays the modal for canceling the action.
   */
  const showCancelModal = () => {
    setModalType('cancel');
    setIsModalVisible(true);
  };

  /**
   * Hides the modal.
   */
  const handleCancel = useCallback(() => {
    setIsModalVisible(false);
  }, []);

  useEffect(() => {
    getTodaysGoldRate();
  }, []);

  const getTodaysGoldRate = async () => {
    const data = await ShowAllData.showDetails(
      'transaction/gold-rates/',
      navigate,
    );

    if (data?.data?.goldRate && Object.keys(data.data.goldRate)?.length > 0) {
      calculate(data?.data?.goldRate?.goldRate);

      const date = data?.data?.goldRate?.englishDate;
      form.setFieldsValue({
        ...data?.data?.goldRate,
        englishDate:
          app?.financialEndYear &&
          new Date(date) > new Date(app.financialEndYear)
            ? dayjs(app.financialEndYear)
            : dayjs(date || getTodaysDateMYD()),

        glod_date_bs:
          app?.financialEndYear &&
          date &&
          new Date(date) > new Date(app.financialEndYear)
            ? getBsFromAD(app.financialEndYear)
            : getBsFromAD(date || getTodaysDateMYD()),
      });
    } else {
      toast.warn("Please select Today's Gold Rate");
    }
  };

  // handle update today's gold rate
  const handleUploadGoldRate = async () => {
    const storeValue = form.getFieldsValue();
    if (
      Number(storeValue.goldRate) === 0 &&
      Number(storeValue.silverRate) === 0
    ) {
      toast.warn('Both Gold and Silver Rate cannot be blank');
      form.getFieldInstance('goldRate').focus();
      return;
    }
    const englishDate = storeValue?.englishDate.format('YYYY-MM-DD');
    const finalValue = {
      ...storeValue,
      englishDate,
    };
    // if (modalType === 'create') {
    try {
      setLoading(true);
      const data = await CreateAllData.createItem(
        'transaction/gold-rates/',
        finalValue,
      );
      if (data.ResponseCode.toString() === STATUS.successCode) {
        showToast(data?.response, 'success');
        const { englishDate } = form.getFieldsValue();
        form.resetFields();
        form.setFieldsValue({
          englishDate,
          glod_date_bs: englishDate && getBsFromAD(englishDate),
        });
      }
      // getTodaysGoldRate();
      refreshTable();
      onClose && onClose();
    } finally {
      setIsModalVisible(false);
      setLoading(false);
    }
    // } else {
    //   setIsModalVisible(false);
    // }
  };

  const { app } = useAppData();

  const [dateType, setDateType] = useState(app?.dateType);

  const handleRadio = (e) => {
    setDateType(e?.target?.value);
  };

  return (
    <>
      <LoadingOverlay loading={loading} />
      {/* <GlobalModal
        isVisible={isModalVisible}
        type={modalType}
        onConfirm={() => {
          handleUploadGoldRate();
          refreshTable();
        }}
        onClose={handleCancel}
      /> */}

      <div>
        <Form
          form={form}
          onFinish={handleUploadGoldRate}
          style={{
            maxWidth: 'none',
            background: token.colorFillAlter,
            borderRadius: token.borderRadiusLG,
            padding: 24,
          }}
        >
          <GlobalDivider name="Today Gold / Silver Rate" />
          <Row justify="end" gutter={[24, 24]}>
            {/* <Form.Item name="nepaliDate" label="BS" className="username">
                <DateField disabled />
              </Form.Item> */}
            {/* <Form.Item name="englishDate" label="Date" className="username">
              <DatePicker
                style={{ width: '100%' }}
                className="date-picker"
                format="YYYY-MM-DD"
              />
            </Form.Item> */}

            <Col xs={24} md={12} lg={2} style={{ marginLeft: 'auto' }}>
              <RadioButtonGroup
                name="date_type"
                initialValue={dateType}
                onChange={handleRadio}
              />
            </Col>
            <Col
              xs={dateType === 'bs' ? 0 : 24}
              md={dateType === 'bs' ? 0 : 12}
              lg={dateType === 'bs' ? 0 : 4}
            >
              <Form.Item name="englishDate" label="Date" className="username">
                <DatePicker
                  allowClear={false}
                  style={{ width: '100%' }}
                  className="date-picker"
                  format="YYYY-MM-DD"
                  disabledDate={(current) =>
                    current.isBefore(app?.financialStartYear, 'day') ||
                    current.isAfter(app?.financialEndYear)
                  }
                  // disabled
                />
              </Form.Item>
            </Col>

            <Col
              xs={dateType === 'ad' ? 0 : 24}
              md={dateType === 'ad' ? 0 : 12}
              lg={dateType === 'ad' ? 0 : 4}
            >
              <NewNepaliDatePicker
                formProps={{
                  name: 'glod_date_bs',
                  label: 'Date:',
                  hidden: dateType === 'ad',
                }}
                disabledBefore={getBsFromAD(app?.financialStartYear)}
                disabledAfter={getBsFromAD(app?.financialEndYear)}
                // disabled
                allowClear={false}
                onChange={(e) => {
                  if (!e) return;
                  if (e > getTodayDate()) {
                    from.setFieldsValue({ glod_date_bs: getTodayDate() });
                    return;
                  }
                  const adDate = getAdFromBS(e);
                  if (adDate) {
                    form.setFieldsValue({ englishDate: adDate });
                  }
                }}
              />
            </Col>
          </Row>
          <Row gutter={[24, 24]}>
            <Col xl={{ span: 6 }} xs={{ span: 24 }}>
              <h4 className="mb-1">Gold Rate</h4>
              <Form.Item name="goldRate" label="24 Carat" className="username">
                <Input
                  // placeholder="24 carat"
                  placeholder={`per one ${primaryCalculationType}`}
                  onChange={(event) => calculate(event.target.value)}
                  suffix={
                    <span className="tw-font-bold tw-text-base">
                      /{primaryCalculationType}
                    </span>
                  }
                />
              </Form.Item>
              <Form.Item
                name="twentyTwoCarat"
                label="22 Carat"
                className="username"
              >
                <Input placeholder="22 carat" disabled />
              </Form.Item>
              <Form.Item
                name="eighteenCarat"
                label="18 Carat"
                className="username"
              >
                <Input placeholder="18 carat" disabled />
              </Form.Item>
            </Col>

            <Col xl={{ span: 6 }} xs={{ span: 24 }}>
              <h4 className="mb-1">Silver Rate</h4>
              <Form.Item name="silverRate" label="" className="font-bold">
                <Input
                  // placeholder="Silver Rate"
                  placeholder={`per one ${primaryCalculationType}`}
                  suffix={
                    <span className="tw-font-bold tw-text-base">
                      /{primaryCalculationType}{' '}
                    </span>
                  }
                />
              </Form.Item>
            </Col>
          </Row>

          <div style={{ textAlign: 'right' }}>
            <Space size="large">
              <AntButton htmlType="submit">Save</AntButton>

              <AntButton
                color="red"
                onClick={() => {
                  form.resetFields();
                  onClose && onClose();
                }}
              >
                Cancel
              </AntButton>
            </Space>
          </div>
        </Form>
      </div>
    </>
  );
};

export default TodayGoldRate;
